module.exports = __webpack_public_path__ + "static/media/seriousMail_de.7c07f24e.png";